import React, { useState, useEffect, useRef } from "react";
import Information from "../../views/home-amc/information/information";
import logo from "../../assets/imgs/navbar/logo_AMC.svg";
import newLogoPng from "../../assets/imgs/navbar/logo-amc-white.png";
import { Link } from "react-router-dom";
import "./navbar.css";
import menuIcon from "../../assets/imgs/navbar/menu-open.svg";
import menuIconClicked from "../../assets/imgs/navbar/menu-closed.svg";
import mexIcon from "../../assets/imgs/navbar/mex_svg.svg";
import usaIcon from "../../assets/imgs/navbar/usa_svg.svg";
import { useTranslation } from "react-i18next";
import BtnSubMenu from "./btnSubMenu/btnSubMenu";
import { useNavigate } from "react-router-dom";
import { FaBars, FaChevronDown, FaChevronUp, FaTimes } from "react-icons/fa";
import { HiOutlineMenuAlt2 } from "react-icons/hi";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { IoSearch } from "react-icons/io5";

function Navbar() {
  const siteHeaderRef = useRef(null);
  const navigate = useNavigate();
  const [tNabvar] = useTranslation("navbar");
  const [tNavRed] = useTranslation("navbarRedesign");
  const [activeButton, setActiveButton] = useState(
    localStorage.getItem("lng") || "es"
  );
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1264);

  const handleLanguageChange = (language) => {
    localStorage.setItem("lng", language);
    const route =
      language === "us"
        ? sessionStorage.getItem("routeEn")
        : sessionStorage.getItem("routeEs");
    if (route) {
      navigate(route);
    }
    window.location.reload();
  };
  const productsData = tNabvar("products-submenu", { returnObjects: true });
  const stationsData = tNabvar("stations-submenu", { returnObjects: true });
  const prepareShipmentData = tNabvar("prepare-shipment-submenu", {
    returnObjects: true,
  });
  const aboutUsData = tNabvar("about-us", { returnObjects: true });
  const closeMobileMenu = () => setClick(false);

  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 1024;
      setIsMobile(mobile);
      // Si cambiamos a desktop, asegurarnos de que el menú esté cerrado
      if (!mobile) {
        setClick(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const headerEl = siteHeaderRef.current;
    if (!headerEl) return undefined;

    const syncHeaderOffset = () => {
      const height = `${headerEl.offsetHeight}px`;
      document.documentElement.style.setProperty("--site-header-offset", height);
      document.documentElement.style.setProperty("--home-header-offset", height);
    };

    syncHeaderOffset();
    const observer = new ResizeObserver(syncHeaderOffset);
    observer.observe(headerEl);
    return () => observer.disconnect();
  }, []);


  // --- ESTADOS PARA EL MÓVIL ---
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  // Estado para controlar qué acordeones están abiertos
  // Usamos un objeto para poder tener múltiples niveles abiertos si se requiere
  const [openAccordions, setOpenAccordions] = useState({});

  const toggleAccordion = (id) => {
    setOpenAccordions(prevState => ({
      ...prevState,
      [id]: !prevState[id] // Invierte el valor (true/false) del id específico
    }));
  };

  return (
    <div className="site-header" ref={siteHeaderRef}>
      <Information />
    {/* MENU TABLETS/MOBILE */}
    <div className="navbar-tablet-mobile">
      <div className="container-fluid py-3" style={{backgroundColor: '#001242'}}>
        <div className="d-flex justify-content-between align-items-center px-3">
            {/* Logo Móvil */}
          <Link to="/">
            <img src={newLogoPng} style={{height: '30px'}} alt="Aeromexico Cargo" />
          </Link>
          
          {/* Botón Buscar y Hamburguesa */}
          <div className="d-flex align-items-center gap-3">
            <Link to="/buscar" onClick={() => setIsMobileMenuOpen(false)}>
              <IoSearch size={24} color="white" />
            </Link>
            <button className="btn-hamburger" onClick={() => setIsMobileMenuOpen(true)}>
              <HiOutlineMenuAlt2 size={24} color="white" />
            </button>
          </div>
        </div>
      </div>

      {/* --- OFFCANVAS (Menú Desplegable) --- */}
      <div className={`mobile-menu-overlay ${isMobileMenuOpen ? 'open' : ''}`}>
        
        {/* Cabecera del Menú */}
        <div className="d-flex justify-content-between align-items-center p-4">
            <img src={newLogoPng} style={{height: '30px'}} alt="Logo" />
            <button className="btn-close-menu" onClick={() => setIsMobileMenuOpen(false)}>
              <HiOutlineMenuAlt2 size={24} color="white" />
            </button>
        </div>

        {/* Cuerpo del Menú */}
        <div className="mobile-menu-body">
          <div className="pb-3 ps-3 gap-2 d-flex justify-content-start">
            <button
              id="btnLangEsp"
              onClick={() => handleLanguageChange("es")}
              className={`btn-language ${
                activeButton === "es" ? "btn-language-active" : ""
              }`}
            >
              <p>ESP</p>
              <img src={mexIcon} alt="México" />
            </button>
            <div className="btn-divider align-self-center">|</div>
            <button
              id="btnLangEng"
              onClick={() => handleLanguageChange("us")}
              className={`btn-language ${
                activeButton === "us" ? "btn-language-active" : ""
              }`}
            >
              <p>ENG</p>
              <img src={usaIcon} alt="México" />
            </button>
          </div>
          
          {/* GESTION DE ENVIOS */}
          <p className="mobile-menu-subtitle">{tNavRed("labels.shipment_management")}</p>
          <Link to={`/${tNavRed("urls.get_quote")}`} className="mobile-menu-link" onClick={() => setIsMobileMenuOpen(false)}>
            {tNavRed("labels.get_quote")}
          </Link>
          
          <Link to={`/${tNabvar("category-services.track")}`} className="mobile-menu-link" onClick={() => setIsMobileMenuOpen(false)}>
              {tNavRed("labels.track_waybill")}
          </Link>

          {/* ACORDEÓN: NOSOTROS */}
          <div className="mobile-menu-accordion">
            <button className="mobile-accordion-header" onClick={() => toggleAccordion('nosotros')}>
              <span>{tNavRed("labels.about_us.title")}</span>
              {openAccordions['nosotros'] ? <IoMdArrowDropup className="accordion-icon"/> : <IoMdArrowDropdown className="accordion-icon"/>}
            </button>
            <div className={`mobile-submenu ${openAccordions['nosotros'] ? 'open' : ''}`}>
                <Link to={`/${tNavRed("urls.about_us.aeromexico_cargo")}`} className="mobile-submenu-link" onClick={() => setIsMobileMenuOpen(false)}>
                  {tNavRed("labels.about_us.aeromexico_cargo")}
                </Link>
                <Link to={`/${tNavRed("urls.about_us.fleet")}`} className="mobile-submenu-link" onClick={() => setIsMobileMenuOpen(false)}>
                  {tNavRed("labels.about_us.fleet")}
                </Link>
                <Link to={`/${tNavRed("urls.about_us.skyteam")}`} className="mobile-submenu-link" onClick={() => setIsMobileMenuOpen(false)}>
                  {tNavRed("labels.about_us.skyteam")}
                </Link>
            </div>
          </div>

          {/* ACORDEÓN: PREPARA TU EMBARQUE */}
          <div className="mobile-menu-accordion">
            <button className="mobile-accordion-header" onClick={() => toggleAccordion('prepara')}>
               <span>{tNavRed("labels.prepare_shipment.title")}</span>
              {openAccordions['prepara'] ? <IoMdArrowDropup className="accordion-icon"/> : <IoMdArrowDropdown className="accordion-icon"/>}
            </button>
            <div className={`mobile-submenu ${openAccordions['prepara'] ? 'open' : ''}`}>
                <Link to={`/${tNavRed("urls.prepare_shipment.restrictions")}`} className="mobile-submenu-link" onClick={() => setIsMobileMenuOpen(false)}>
                  {tNavRed("labels.prepare_shipment.restrictions")}
                </Link>
                <Link to={`/${tNavRed("urls.prepare_shipment.general_cargo")}`} className="mobile-submenu-link" onClick={() => setIsMobileMenuOpen(false)}>
                  {tNavRed("labels.prepare_shipment.general_cargo")}
                </Link>
                <Link to={`/${tNavRed("urls.prepare_shipment.label_generator")}`} className="mobile-submenu-link" onClick={() => setIsMobileMenuOpen(false)}>
                  {tNavRed("labels.prepare_shipment.label_generator")}
                </Link>
            </div>
          </div>

          {/* SERVICIOS Y ESTACIONES */}
          <p className="mobile-menu-subtitle mt-3">{tNavRed("labels.services_stations")}</p>
          {/* ACORDEÓN: SERVICIOS */}
          <div className="mobile-menu-accordion">
            <button className="mobile-accordion-header" onClick={() => toggleAccordion('servicios')}>
              <span>{tNavRed("labels.services.title")}</span>
              {openAccordions['servicios'] ? <IoMdArrowDropup className="accordion-icon"/> : <IoMdArrowDropdown className="accordion-icon"/>}
            </button>

            {/* Contenedor Nivel 1 */}
            <div className={`mobile-submenu ${openAccordions['servicios'] ? 'open' : ''}`}>
              
              {/* --- OPCIÓN 1: NACIONALES (Nivel 2) --- */}
              {/* Nota: Si Nacionales también tiene submenú, usamos botón toggle. Si es link directo, usa Link */}
              <div>
                  <button 
                    className="mobile-accordion-header" 
                    style={{ paddingLeft: '40px' }} // Sangría Nivel 2
                    onClick={() => toggleAccordion('nacionales')}
                  >
                    <span>{tNavRed("labels.services.national.title")}</span>
                    {openAccordions['nacionales'] ? <IoMdArrowDropup className="accordion-icon"/> : <IoMdArrowDropdown className="accordion-icon"/>}
                  </button>
                  
                  {/* Submenú Nacionales */}
                  <div className={`mobile-submenu ${openAccordions['nacionales'] ? 'open' : ''}`}>
                      <Link to={`/${tNavRed("urls.services.national.gold")}`} className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>{tNavRed("labels.services.national.gold")}</Link>
                      <Link to={`/${tNavRed("urls.services.national.twelve_twelve")}`} className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>{tNavRed("labels.services.national.twelve_twelve")}</Link>
                      <Link to={`/${tNavRed("urls.services.national.messaging")}`} className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>{tNavRed("labels.services.national.messaging")}</Link>
                      <Link to={`/${tNavRed("urls.services.national.perishables")}`} className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>{tNavRed("labels.services.national.perishables")}</Link>
                      <Link to={`/${tNavRed("urls.services.national.high_value")}`} className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>{tNavRed("labels.services.national.high_value")}</Link>
                      <Link to={`/${tNavRed("urls.services.national.high_tech")}`} className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>{tNavRed("labels.services.national.high_tech")}</Link>
                      <Link to={`/${tNavRed("urls.services.national.live_animals")}`} className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>{tNavRed("labels.services.national.live_animals")}</Link>
                      <Link to={`/${tNavRed("urls.services.national.human_remains")}`} className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>{tNavRed("labels.services.national.human_remains")}</Link>
                      <Link to={`/${tNavRed("urls.services.national.pharma_xps")}`} className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>{tNavRed("labels.services.national.pharma_xps")}</Link>
                      <Link to={`/${tNavRed("urls.services.national.pharma_std")}`} className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>{tNavRed("labels.services.national.pharma_std")}</Link>
                      <Link to={`/${tNavRed("urls.services.national.valise")}`} className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>{tNavRed("labels.services.national.valise")}</Link>
                      <Link to={`/${tNavRed("urls.services.national.dangerous_goods")}`} className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>{tNavRed("labels.services.national.dangerous_goods")}</Link>
                      <Link to={`/${tNavRed("urls.services.national.industry")}`} className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>{tNavRed("labels.services.national.industry")}</Link>
                  </div>
              </div>

              {/* --- OPCIÓN 2: INTERNACIONALES (Nivel 2) --- */}
              <div>
                  <button 
                    className="mobile-accordion-header" 
                    style={{ paddingLeft: '40px' }} // Sangría Nivel 2
                    onClick={() => toggleAccordion('internacionales')}
                  >
                    <span>{tNavRed("labels.services.international.title")}</span>
                    {openAccordions['internacionales'] ? <IoMdArrowDropup className="accordion-icon"/> : <IoMdArrowDropdown className="accordion-icon"/>}
                  </button>

                  {/* Contenedor Nivel 2 (Internacionales) */}
                  <div className={`mobile-submenu ${openAccordions['internacionales'] ? 'open' : ''}`}>
                      
                      {/* Opción A: Express */}
                      <Link to={`/${tNavRed("urls.services.international.express")}`} className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>
                        {tNavRed("labels.services.international.express")}
                      </Link>

                      {/* Opción B: General */}
                      <Link to={`/${tNavRed("urls.services.international.general")}`} className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>
                        {tNavRed("labels.services.international.general")}
                      </Link>

                      {/* Opción: SPECIALIZED (Nivel 3 - Con Submenú) */}
                      <div>
                          <button 
                            className="mobile-accordion-header" 
                            style={{ paddingLeft: '60px' }} // Sangría Nivel 3
                            onClick={() => toggleAccordion('specialized')}
                          >
                            <span>{tNavRed("labels.services.international.specialized.title")}</span>
                            {openAccordions['specialized'] ? <IoMdArrowDropup className="accordion-icon"/> : <IoMdArrowDropdown className="accordion-icon"/>}
                          </button>

                          {/* Contenedor Nivel 3 (Opciones de Specialized) */}
                          <div className={`mobile-submenu ${openAccordions['specialized'] ? 'open' : ''}`}>
                              <Link to={`/${tNavRed("urls.services.international.specialized.art")}`} className="mobile-submenu-link" style={{paddingLeft: '80px'}} onClick={() => setIsMobileMenuOpen(false)}>Specialized Art</Link>
                              <Link to={`/${tNavRed("urls.services.international.specialized.care")}`} className="mobile-submenu-link" style={{paddingLeft: '80px'}} onClick={() => setIsMobileMenuOpen(false)}>Specialized Care</Link>
                              <Link to={`/${tNavRed("urls.services.international.specialized.dgr")}`} className="mobile-submenu-link" style={{paddingLeft: '80px'}} onClick={() => setIsMobileMenuOpen(false)}>Specialized DGR</Link>
                              <Link to={`/${tNavRed("urls.services.international.specialized.fresh")}`} className="mobile-submenu-link" style={{paddingLeft: '80px'}} onClick={() => setIsMobileMenuOpen(false)}>Specialized Fresh</Link>
                              <Link to={`/${tNavRed("urls.services.international.specialized.live")}`} className="mobile-submenu-link" style={{paddingLeft: '80px'}} onClick={() => setIsMobileMenuOpen(false)}>Specialized Live</Link>
                              <Link to={`/${tNavRed("urls.services.international.specialized.pharma")}`} className="mobile-submenu-link" style={{paddingLeft: '80px'}} onClick={() => setIsMobileMenuOpen(false)}>Specialized Pharma</Link>
                              <Link to={`/${tNavRed("urls.services.international.specialized.safe")}`} className="mobile-submenu-link" style={{paddingLeft: '80px'}} onClick={() => setIsMobileMenuOpen(false)}>Specialized Safe</Link>
                          </div>
                      </div>
                      {/* Fin Specialized */}

                      {/* Opción: Customized */}
                      <Link to={`/${tNavRed("urls.services.international.customized")}`} className="mobile-submenu-link" style={{paddingLeft: '60px'}} onClick={() => setIsMobileMenuOpen(false)}>
                        {tNavRed("labels.services.international.customized")}
                      </Link>

                  </div>
              </div>

              {/* --- OPCIÓN 3: ADICIONALES --- */}
              <Link to="/servicios/adicionales" className="mobile-submenu-link" style={{paddingLeft: '40px'}} onClick={() => setIsMobileMenuOpen(false)}>
                {tNavRed("labels.services.additional")}
              </Link>

            </div>
          </div>
          {/* ACORDEÓN: ESTACIONES */}
          <div className="mobile-menu-accordion">
            <button className="mobile-accordion-header" onClick={() => toggleAccordion('estaciones')}>
              {tNavRed("labels.stations.title")}
              {openAccordions['estaciones'] ? <IoMdArrowDropup className="accordion-icon"/> : <IoMdArrowDropdown className="accordion-icon"/>}
            </button>
            <div className={`mobile-submenu ${openAccordions['estaciones'] ? 'open' : ''}`}>
                <Link to={`/${tNavRed("urls.stations.national")}`} className="mobile-submenu-link" onClick={() => setIsMobileMenuOpen(false)}>
                  {tNavRed("labels.stations.national")}
                </Link>
                <Link to={`/${tNavRed("urls.stations.international")}`} className="mobile-submenu-link" onClick={() => setIsMobileMenuOpen(false)}>
                  {tNavRed("labels.stations.international")}
                </Link>
                <Link to={`/${tNavRed("urls.stations.warehouses")}`} className="mobile-submenu-link" onClick={() => setIsMobileMenuOpen(false)}>
                  {tNavRed("labels.stations.warehouses")}
                </Link>
            </div>
          </div>

          {/* SERVICIOS Y ESTACIONES */}
          <p className="mobile-menu-subtitle mt-3">{tNavRed("labels.information")}</p>
          <Link to="/contratos" className="menu-information-links">{tNavRed("labels.contracts")}</Link>
          <Link to="/" className="menu-information-links">{tNavRed("labels.privacy")}</Link>
          <Link to="/cumplimiento-normativo" className="menu-information-links">Compliance</Link>
        </div>
      </div>
    </div>

    {/* MENU DESKTOP */}
    <div className="container-fluid navbar-redesgin navbar-desktop">
      <div className="row align-items-center">
        <div className="col d-flex justify-content-between align-items-center">
          <div className="nav-left-side">
            <Link to="/">
              <img src={newLogoPng} className="nav-logo" alt="Aeromexico Cargo" />
            </Link>
            <nav className="nav-links-main">
              <Link to={`/${tNavRed("urls.get_quote")}`} className="nav-item">{tNavRed("labels.get_quote")}</Link>
              <Link to={`/${tNabvar("category-services.track")}`} className="nav-item">{tNavRed("labels.track_waybill")}</Link>
              
              {/* --- INICIO MENU DESPLEGABLE NOSOTROS --- */}
              <div className="dropdown-wrapper-2">
                <span className="nav-item">
                  {tNavRed("labels.about_us.title")}
                  <IoMdArrowDropdown className="nav-icon-pink" />
                </span>

                <ul className="dropdown-menu-2 menu-left">
                  <li className="dropdown-item">
                    <Link to={`/${tNavRed("urls.about_us.aeromexico_cargo")}`}>{tNavRed("labels.about_us.aeromexico_cargo")}</Link>
                  </li>
                  <li className="dropdown-item">
                    <Link to={`/${tNavRed("urls.about_us.fleet")}`}>{tNavRed("labels.about_us.fleet")}</Link>
                  </li>
                  <li className="dropdown-item">
                    <Link to={`/${tNavRed("urls.about_us.skyteam")}`}>{tNavRed("labels.about_us.skyteam")}</Link>
                  </li>
                </ul>
              </div>

              {/* --- INICIO MENU DESPLEGABLE PREPARA TU EMBARQUE --- */}
              <div className="dropdown-wrapper-2">
                <span className="nav-item">
                  {tNavRed("labels.prepare_shipment.title")}
                  <IoMdArrowDropdown className="nav-icon-pink" />
                </span>

                <ul className="dropdown-menu-2 menu-left">
                  <li className="dropdown-item">
                    <Link to={`/${tNavRed("urls.prepare_shipment.restrictions")}`}>{tNavRed("labels.prepare_shipment.restrictions")}</Link>
                  </li>
                  <li className="dropdown-item">
                    <Link to={`/${tNavRed("urls.prepare_shipment.general_cargo")}`}>{tNavRed("labels.prepare_shipment.general_cargo")}</Link>
                  </li>
                  <li className="dropdown-item">
                    <Link to={`/${tNavRed("urls.prepare_shipment.label_generator")}`}>{tNavRed("labels.prepare_shipment.label_generator")}</Link>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
          <div className="nav-right-side">
            <nav className="nav-links-secondary">
              {/* Botón Buscar */}
              <Link to="/buscar" className="search-circle">
                <IoSearch size={16} color="white" />
              </Link>

              {/* --- INICIO DEL DROPDOWN DE SERVICIOS --- */}
              <div className="dropdown-wrapper-2">
                <span className="nav-item">
                  {tNavRed("labels.services.title")}
                  <IoMdArrowDropdown className="nav-icon-pink" />
                </span>

                {/* Nivel 1: Menú Principal (Vertical) */}
                <ul className="dropdown-menu-2">
                  
                  {/* Opción 1: Nacionales */}
                  <li className="dropdown-item has-submenu">
                    <Link to={`/${tNavRed("urls.services.national.main")}`}>{tNavRed("labels.services.national.title")}</Link>
                    <ul className="submenu-2">
                      <li><Link to={`/${tNavRed("urls.services.national.gold")}`}>{tNavRed("labels.services.national.gold")}</Link></li>
                      <li><Link to={`/${tNavRed("urls.services.national.twelve_twelve")}`}>{tNavRed("labels.services.national.twelve_twelve")}</Link></li>
                      <li><Link to={`/${tNavRed("urls.services.national.messaging")}`}>{tNavRed("labels.services.national.messaging")}</Link></li>
                      <li><Link to={`/${tNavRed("urls.services.national.perishables")}`}>{tNavRed("labels.services.national.perishables")}</Link></li>
                      <li><Link to={`/${tNavRed("urls.services.national.high_value")}`}>{tNavRed("labels.services.national.high_value")}</Link></li>
                      <li><Link to={`/${tNavRed("urls.services.national.high_tech")}`}>{tNavRed("labels.services.national.high_tech")}</Link></li>
                      <li><Link to={`/${tNavRed("urls.services.national.live_animals")}`}>{tNavRed("labels.services.national.live_animals")}</Link></li>
                      <li><Link to={`/${tNavRed("urls.services.national.human_remains")}`}>{tNavRed("labels.services.national.human_remains")}</Link></li>
                      <li><Link to={`/${tNavRed("urls.services.national.pharma_xps")}`}>{tNavRed("labels.services.national.pharma_xps")}</Link></li>
                      <li><Link to={`/${tNavRed("urls.services.national.pharma_std")}`}>{tNavRed("labels.services.national.pharma_std")}</Link></li>
                      <li><Link to={`/${tNavRed("urls.services.national.valise")}`}>{tNavRed("labels.services.national.valise")}</Link></li>
                      <li><Link to={`/${tNavRed("urls.services.national.dangerous_goods")}`}>{tNavRed("labels.services.national.dangerous_goods")}</Link></li>
                      <li><Link to={`/${tNavRed("urls.services.national.industry")}`}>{tNavRed("labels.services.national.industry")}</Link></li>
                    </ul>
                  </li>

                  {/* Opción 2: Internacionales */}
                  <li className="dropdown-item has-submenu">
                    <Link to={`/${tNavRed("urls.services.international.main")}`}>{tNavRed("labels.services.international.title")}</Link>
                    <ul className="submenu-2">
                      <li><Link to={`/${tNavRed("urls.services.international.express")}`}>{tNavRed("labels.services.international.express")}</Link></li>
                      <li><Link to={`/${tNavRed("urls.services.international.general")}`}>{tNavRed("labels.services.international.general")}</Link></li>

                      {/* NIVEL 3 (Specialized) --- */}
                      <li className="position-relative has-submenu-level-3"> 
                        <Link to={`/${tNavRed("urls.services.international.specialized.main")}`} className="d-flex justify-content-between align-items-center">
                          {tNavRed("labels.services.international.specialized.title")}
                          {/* Opcional: una flechita para indicar que hay más */}
                          <span style={{fontSize: '10px'}}>▸</span>
                        </Link>
                        <ul className="submenu-3">
                          <li><Link to={`/${tNavRed("urls.services.international.specialized.art")}`}>Specialized Art</Link></li>
                          <li><Link to={`/${tNavRed("urls.services.international.specialized.care")}`}>Specialized Care</Link></li>
                          <li><Link to={`/${tNavRed("urls.services.international.specialized.dgr")}`}>Specialized DGR</Link></li>
                          <li><Link to={`/${tNavRed("urls.services.international.specialized.fresh")}`}>Specialized Fresh</Link></li>
                          <li><Link to={`/${tNavRed("urls.services.international.specialized.live")}`}>Specialized Live</Link></li>
                          <li><Link to={`/${tNavRed("urls.services.international.specialized.pharma")}`}>Specialized Pharma</Link></li>
                          <li><Link to={`/${tNavRed("urls.services.international.specialized.safe")}`}>Specialized Safe</Link></li>
                        </ul>
                      </li>
                      {/* --- FIN DEL NIVEL 3 --- */}
                      <li><Link to={`/${tNavRed("urls.services.international.customized")}`}>{tNavRed("labels.services.international.customized")}</Link></li>
                    </ul>
                  </li>

                  {/* Opción 3: Servicios Adicionales */}
                  <li className="dropdown-item">
                    <Link to={`/${tNavRed("urls.services.additional")}`}>{tNavRed("labels.services.additional")}</Link>
                  </li>
                </ul>
              </div>
              {/* --- FIN DEL DROPDOWN --- */}
              
              {/* --- INICIO MENU DESPLEGABLE ESTACIONES --- */}
              <div className="dropdown-wrapper-2">
                <span className="nav-item">
                    {tNavRed("labels.stations.title")}
                    <IoMdArrowDropdown className="nav-icon-pink" />
                </span>

                <ul className="dropdown-menu-2 menu-left">
                  <li className="dropdown-item">
                    <Link to={`/${tNavRed("urls.stations.national")}`}>{tNavRed("labels.stations.national")}</Link>
                  </li>
                  <li className="dropdown-item">
                    <Link to={`/${tNavRed("urls.stations.international")}`}>{tNavRed("labels.stations.international")}</Link>
                  </li>
                  <li className="dropdown-item">
                    <Link to={`/${tNavRed("urls.stations.warehouses")}`}>{tNavRed("labels.stations.warehouses")}</Link>
                  </li>
                </ul>
              </div>
            </nav>
            <div className="py-2 py-lg-0 ps-3 gap-2 d-flex justify-content-start bg-gray order-first order-lg-last">
              <button
                id="btnLangEsp"
                onClick={() => handleLanguageChange("es")}
                className={`btn-language ${
                  activeButton === "es" ? "btn-language-active" : ""
                }`}
              >
                <p>ESP</p>
                <img src={mexIcon} alt="México" />
              </button>
              <div className="btn-divider align-self-center">|</div>
              <button
                id="btnLangEng"
                onClick={() => handleLanguageChange("us")}
                className={`btn-language ${
                  activeButton === "us" ? "btn-language-active" : ""
                }`}
              >
                <p>ENG</p>
                <img src={usaIcon} alt="México" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
}

export default Navbar;
